import { qataQuestions2025, mainSettings2025,startScoutPage2025,initialPage2025,additionalInfoObject2025 } from "./config2025";
import { qataQuestions2026, mainSettings2026,startScoutPage2026,initialPage2026,additionalInfoObject2026, extraDatapoints2026 } from "./config2026";
import { mainSettings8888, fieldCrossing8888 } from "./config2026_2";
import { gridSettings2026 } from './config2026';
import { gridSettings2025 } from './config2025';
import { gridSettings8888 } from './config2026_2';
import versionInfo from '../version.json';
const OSPREY_VERSION = versionInfo.version;

const baseInfoObject = {
    basic:{
        title: "How to Scout",
        info: [
            {
                subtitle: "Setup",
                text: (
                    <>
                        Enter the basic information on the home screen. Tap <em>Scout</em> to enter the match and robot numbers.
                         If an event path was set earlier, the robot number will appear automatically. 
                         Tap <em>Begin</em> to start scouting.
                    </>
                )
            },
            {
                subtitle: "Scouting",
                text: (
                    <>
                        Increment data points by clicking, tapping, or using the assigned keybind. 
                        To decrement, hold <em>Shift</em> while clicking/tapping/using the keybind, or swipe 
                        left on the button. To add notes, press <em>Alt</em> or tap the team number area to open a text box.
                    </>
                )
            },
            {
                subtitle: "Post Match",
                text: (
                    <>
                        On the post-match screen, review all data and press <em>Upload</em>. 
                        Uploading requires signing in with an authorized email. 
                        If not signed in or if no network connection, press <em>Continue</em> to save the match locally, 
                        where it can be accessed from the Search page.
                    </>
                )
            },
            {
                subtitle: "Other",
                text: (
                    <>
                        If other scouting questions either contact a 3128 member or check our <a style={{color:"var(--accentColor"}} href="https://docs.google.com/document/d/1elVty8cS8I4PfJ1jD1sCEqSmCIBOHVK3ZG2N2PpJiG4" target="blank">Complete Scouting Guide Document</a>.
                    </>
                )
            }
        ]
    }
}

export const nonUploadedData = ["event_path","upload_type"]

/**
 * Config for all things
 */
export const masterConfig = {
    2025: {
        mainSettings: mainSettings2025,
        gridSettings: gridSettings2025,
        qataQuestions: qataQuestions2025,
        startScoutPage: startScoutPage2025,
        initialPage: initialPage2025,
        informationMegaObject: (() => {
            let ordered = {};
            for (const [k, v] of Object.entries(baseInfoObject)) ordered[k] = v;
            for (const [k, v] of Object.entries(additionalInfoObject2025)) ordered[k] = v;
            return ordered;
        })(),
        extraDatapoints: []
    },
    2026: {
        mainSettings: mainSettings2026,
        gridSettings: gridSettings2026,
        qataQuestions: qataQuestions2026,
        startScoutPage: startScoutPage2026,
        initialPage: initialPage2026,
        informationMegaObject: (() => {
            let ordered = {};
            for (const [k, v] of Object.entries(baseInfoObject)) ordered[k] = v;
            for (const [k, v] of Object.entries(additionalInfoObject2026)) ordered[k] = v;
            return ordered;
        })(),
        extraDatapoints: extraDatapoints2026
    },
    8888:{ //second counting mode for 2026
        mainSettings: mainSettings8888,
        gridSettings: gridSettings8888,
        fieldCrossing: fieldCrossing8888
    }
    // add more years here...
};

/**
 * Creates a data array of all data points with key/value pairs in their empty state
 * @returns {Array<Array<String>>} the empty version of the data array
 */
export function getDataArray(year = 2025) {
    const dataArray = [];
    const settings = {...masterConfig[year]["mainSettings"]}
    for (const point of formFields(settings)) {
        dataArray.push([point.label, emptyValue(point)]);
    }
    dataArray.push(["version", OSPREY_VERSION])
    return dataArray;
}

/** Every data point a form declares, in page order. */
function formFields(settings) {
    return [settings.start, settings.auto, settings.tele, settings.after]
        .filter(Array.isArray)
        .flat();
}

/**
 * The value a data point holds before the scout touches it.
 * A popup - the auto path - is an empty list: "no path drawn", the same type as a
 * drawn one, so the field is never absent and never a different shape.
 */
export function emptyValue(point) {
    switch (point.writeType) {
        case "str":
            return "";
        case "bool":
            return false;
        case "cycG":
            return point.cycGOptions[0];
        case "tog":
        case "popup":
            return [];
        default:
            return 0;
    }
}

/** Labels the form declares that this record does not have yet. */
export function missingFields(map, settings) {
    return formFields(settings).map(point => point.label).filter(label => !map.has(label));
}

/**
 * The record with every field its form declares, empty ones at their empty value.
 *
 * The starting record is built from the year's base form, but the scout may be using
 * another - 2026 count mode adds auto_field, which the base form lacks. Without this,
 * a match with no path drawn left the field out entirely, and Octopus filed it in a
 * different version table from a match with one. Existing values are never touched;
 * returns the same map when nothing is missing, so a caller can skip a state update.
 */
export function fillMissingFields(map, settings) {
    const missing = formFields(settings).filter(point => !map.has(point.label));
    if (missing.length === 0) return map;
    const filled = new Map(map);
    for (const point of missing) filled.set(point.label, emptyValue(point));
    return filled;
}


/**
 * All app color themes
 */
export const themes = {
    "styleNarwhal": ["#d8dee9", "#617b94", "#242933", "#1b1f27", "#bf616a", "invert(92%) sepia(7%) saturate(277%) hue-rotate(180deg) brightness(97%) contrast(92%) opacity(50%)"],
    "styleBeluga": ["#242933", "#617b94", "#d8dee9", "#f0f4f8", "#bf616a", "invert(8%) sepia(7%) saturate(277%) hue-rotate(180deg) brightness(103%) contrast(108%) opacity(50%)"],
    // maincolor, sub/accent, bg, highlight/altbg, error, filter for img icons
    "styleOlivia": ["#ccc4bfff", "#deaf9d", "#1c1b1d", "#4e3e3e", "#bf616a", "invert(97%) sepia(47%) saturate(304%) hue-rotate(292deg) brightness(104%) contrast(90%) opacity(50%)"],
    "styleLavender": ["#54338e", "#9375c7", "#c4b2e3", "#e3daf2", "#e67bdfff", "invert(11%) sepia(32%) saturate(6816%) hue-rotate(238deg) brightness(97%) contrast(99%) opacity(50%)"],
    "styleCarbon": ["#d8d6d6ff", "#444", "#111", "#191919", "#da3333", "invert(100%) sepia(0%) saturate(6935%) hue-rotate(270deg) brightness(111%) contrast(87%) opacity(50%)"],
    "styleEvergreen": ["#edf5e1", "#cfb117ff", "#286242ff", "#8ee4af", "#379683", "invert(96%) sepia(9%) saturate(491%) hue-rotate(43deg) brightness(106%) contrast(92%) opacity(50%)"],
    "styleForest": ["#75ae8eff", "#2d6a4f", "#081c15", "#1b4332", "#d90429", "invert(65%) sepia(22%) saturate(542%) hue-rotate(90deg) brightness(85%) contrast(92%) opacity(50%)"],
    "styleRupert": ["#a8a7a7ff","#c70017ff","#1A1A1A","#2C2C2C","#FF0000","invert(0%) sepia(15%) saturate(900%) hue-rotate(0deg) brightness(100%) contrast(105%) opacity(50%)"],
    "styleCoral": ["#F8F8F2","#BD93F9","#6272A4","#44475A","#FF5555","invert(0%) sepia(20%) saturate(600%) hue-rotate(270deg) brightness(95%) contrast(100%) opacity(50%)"],    
    // "styleClown": ["#5D3A5B","#FFD966","#FF7F50","#4BCFE1","#D9534F","invert(0%) sepia(10%) saturate(600%) hue-rotate(180deg) brightness(100%) contrast(100%) opacity(50%)"],
    "styleSmile": ["#f6ff00", "#f6ff00", "#f6ff00", "#f6ff00", "#f6ff00", "invert(14%) sepia(85%) saturate(3624%) hue-rotate(340deg) brightness(92%) contrast(97%)"],
    "styleIceberg": ["#212b43", "#62cfe6", "#f3fdff", "#ddeff3", "#e58c9d", "invert(16%) sepia(9%) saturate(2627%) hue-rotate(185deg) brightness(95%) contrast(96%) opacity(50%)"],
    "styleLemono": ["#ffffff","#3cd52e","#242424","#3e3e3e","#d32f2f","invert(0%) sepia(20%) saturate(800%) hue-rotate(90deg) brightness(95%) contrast(100%) opacity(50%)"],
    "styleMatch_13": ["#094a58", "#00b6ae", "#fff", "#c1c1c1", "#b94e4eff", "invert(22%) sepia(51%) saturate(742%) hue-rotate(143deg) brightness(94%) contrast(96%) opacity(50%)"],
    "styleUgly": ["#e8e8e8", "#feff04", "#212121", "rgba(92,74,156,0.5)", "#da3333", "invert(100%) sepia(2%) saturate(421%) hue-rotate(168deg) brightness(115%) contrast(82%) opacity(50%)"],
    "styleHamilton": ["#0b761a","#e3b92e","#f2f2f2","#d4d4d4","#c44d00","invert(10%) sepia(20%) saturate(600%) hue-rotate(90deg) brightness(100%) contrast(95%) opacity(50%)"]
}

/**
 * The order that the themes arrays are in except for filter
 */
export const themeConfig = ["Text Color", "Accent Color", "Background", "Alt Background", "Error"];

/**
 * These are the different upload modes
 */
export const gamemodes = [
        "Prescouting",
        "Practice Matches",
        "Quals",
        "Elims",
        "Timestamp"
    ]
export const elimsPositions = [
    "Alliance Captain",
    "First Pick",
    "Second Pick"
]